import * as React from 'react';

import { StructureType } from '__generated__/api/types';

export interface MainRegionProps {
  className?: string;
  structure?: string;
}

export class MainRegion extends React.Component<MainRegionProps> {
  public static defaultProps = {
    className: '',
  };

  public render() {
    const { className, structure } = this.props;

    let schemaItemType = 'Hotel';

    switch (structure) {
      case StructureType.BED_AND_BREAKFAST:
        schemaItemType = 'BedAndBreakfast';
        break;
      case StructureType.CARAVAN_PARK:
        schemaItemType = 'Campground';
        break;
      case StructureType.HOSTEL:
        schemaItemType = 'Hostel';
        break;
      case StructureType.MOTEL:
        schemaItemType = 'Motel';
        break;
      case StructureType.HOTEL_RESORT:
        schemaItemType = 'Resort';
        break;
      default:
        break;
    }

    return (
      <main className={`${className}`} itemScope={true} itemType={`https://schema.org/${schemaItemType}`}>
        {this.props.children}
      </main>
    );
  }
}
